import { useResource } from '@landsbankinn/l16n';
import { Box, H3, P, ShortSplitter, Span } from '@landsbankinn/ui-kit';
import { Layout } from '../Layout';
import { errorRes } from './Error.res';

export function Error({
  title,
  description,
  traceparent,
}: {
  title: string;
  description: string;
  traceparent: string;
}) {
  const { r } = useResource();
  return (
    <Layout>
      <Box color="blue font">
        <H3 fontVariant="h3">{title}</H3>
        <ShortSplitter height="32" />
        <Span fontVariant="label">{r(errorRes.description)}</Span>
        <P fontVariant="body">{description}</P>
        <Span fontVariant="label">{r(errorRes.traceparent)}</Span>
        <P fontVariant="body">{traceparent}</P>
      </Box>
    </Layout>
  );
}
